import { defineModule, } from 'direct-vuex';
import { getAllAlerts, } from '../env';
import { BrandColoursType, isBrandColour, } from '../resources';

export interface Alert {
	id: string;
	colour: BrandColoursType;
	content: string;
	icon?: string;
	iconHtml?: string;
}

export interface AlertModuleState {
	activeAlert: Alert | null;
	dismissedAlerts: Set<string>;
}

const allAlerts = getAllAlerts();

function findMatchingAlert(path: string, state: AlertModuleState): Alert | null {
	if (!path || !allAlerts || allAlerts.length < 1) {
		return null;
	}

	for (let index = 0; index < allAlerts.length; index++) {
		const { UrlMatch, Alert, } = allAlerts[index];
		if (UrlMatch.toLocaleLowerCase() === path.toLocaleLowerCase()) {
			if (!Alert || state.dismissedAlerts.has(Alert.Id)) {
				return null;
			}

			const colour = isBrandColour(Alert.Colour) ? Alert.Colour : 'pacific';
			return {
				id: Alert.Id,
				colour,
				content: Alert.Content,
				iconHtml: Alert.IconHtml,
				icon: Alert.Icon,
			};
		}
	}

	let nextPath = path.substr(0, path.lastIndexOf('/'));
	if (nextPath === '') {
		nextPath = '/';
	}

	if (nextPath === path) {
		return null;
	}

	return findMatchingAlert(nextPath, state);
}

export default defineModule({
	namespaced: false as const,
	state: {
		activeAlert: null,
		dismissedAlerts: new Set<string>(),
	} as AlertModuleState,
	getters: { },
	mutations: {
		dismissActiveAlert(state) {
			if (state.activeAlert === null) {
				return;
			}

			const dismissedAlerts = state.dismissedAlerts;
			dismissedAlerts.add(state.activeAlert.id);
			window.dispatchEvent(new CustomEvent('sw:alert:close', {
				detail: {
					id: state.activeAlert.id,
				},
			}));
			state.activeAlert = null;
		},
		setActiveAlert(state, currentPath: string) {
			const alert = findMatchingAlert(currentPath, state);
			if (alert === null) {
				state.activeAlert = null;
				return;
			}
			state.activeAlert = alert;
		},
	},
});
